export default {
    crop: {
        title: "Recadrer",
        cropSize: "Taille de la récolte",
        zoom: "Zoom",
        custom: 'Custom',
        post: 'Poste',
        square: 'Square',
        landscape: 'Paysage',
        story: 'Histoire',
        portrait: 'Portrait',
        carousel: 'Carrousel',
        commonAspectRatio: "Ratio d'aspect courant",
    },
};
